module.exports = __webpack_public_path__ + "static/media/Illus-LoyaltyBloom@3x.f37df145.png";